/**
 * Fetches GET /api/v3/organizations/{orgId} when step=2 so CreateOrganization can prefill step 1 form.
 * Single Responsibility: fetch org when needed for prefill.
 */

import { useState, useEffect } from 'react';
import { getOrganizationById } from '../../../services/real/organizationService.real';

/**
 * @param {string | null | undefined} orgId - From auth state (user.organization ?? user.organizationId)
 * @param {string | null} step - From URL ?step= (e.g. '2')
 * @returns {{ organization: object | null, loading: boolean }}
 */
export function useOrganizationForCreatePage(orgId, step) {
  const [state, setState] = useState({ organization: null, loading: false });

  useEffect(() => {
    const shouldFetch = step === '2' && orgId != null && orgId !== '';
    if (!shouldFetch) {
      setState({ organization: null, loading: false });
      return;
    }

    setState((s) => ({ ...s, loading: true }));

    getOrganizationById(orgId)
      .then((org) => {
        const normalized = org?.data ?? org ?? null;
        setState({ organization: normalized, loading: false });
      })
      .catch(() => {
        setState({ organization: null, loading: false });
      });
  }, [orgId, step]);

  return state;
}
